import { Service } from '~publish/legacy/constants/services/ServiceDefinitions'

/**
 * Services whose platform API gives no access to comments or mentions, so
 * Community can never support them.
 *
 * When a service is in this list, the single-channel empty state shows the
 * "Community is not supported for {Name}." title with no body copy — no
 * feedback ask and no promise of future support.
 */
export const NEVER_SUPPORTED_SERVICES: readonly Service[] = [
  Service.Pinterest,
  Service.StartPage,
]

export function isNeverSupportedService(
  service: string,
  denylist: readonly Service[] = NEVER_SUPPORTED_SERVICES,
): boolean {
  return denylist.some((deniedService) => deniedService === service)
}
